export default "__VITE_ASSET__DY5ePvcw__"